import { DESTINATIONS, DESTINATION_MAP } from '../../constants';

export const getRedirectDestinationSlugs = (destination?: (typeof DESTINATIONS)[number]) => {
  if (!destination) {
    return null;
  }

  return DESTINATION_MAP[destination];
};
